const { REACT_APP_FACEBOOK_PIXEL_ID } = process.env;

const FACEBOOK_EVENTS = {
  CONTACT: "Contact",
  COMPLETE_REGISTRATION: "CompleteRegistration",
  CONVERSION: "Lead",
  PAGE_VIEW: "PageView",
};

const FACEBOOK_SCRIPT_ID = "facebook-pixel-script";
const FACEBOOK_SDK_PROP_NAME = "fbq";

let pageViewFired = false;
const fireFacebookEvent = async (eventName) => {
  try {
    if (!window[FACEBOOK_SDK_PROP_NAME]) {
      console.warn("fbq not initialized");
      return;
    }
    if (!pageViewFired) {
      window[FACEBOOK_SDK_PROP_NAME]("track", FACEBOOK_EVENTS.PAGE_VIEW);
      pageViewFired = true;
    }
    // SDK already present
    window[FACEBOOK_SDK_PROP_NAME]("track", eventName);
  } catch (error) {
    console.error("FBQ: Error firing Facebook event ", error);
  }
};

export const initFacebookPixel = () => {
  try {
    // Avoid double-loading
    if (window.fbq || document.getElementById(FACEBOOK_SCRIPT_ID)) return;

    // Create inline script to define fbq and initialize
    // add id to script to avoid duplicate
    const inlineScript = document.createElement("script");
    inlineScript.id = FACEBOOK_SCRIPT_ID;

    inlineScript.innerHTML = `
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );

      fbq('init', '${REACT_APP_FACEBOOK_PIXEL_ID}');
    `;

    document.head.appendChild(inlineScript);
  } catch (error) {
    console.error("FBQ: Error initializing Facebook Pixel ", error);
  }
};

export const fireFacebookConversion = () =>
  fireFacebookEvent(FACEBOOK_EVENTS.CONVERSION);

export const fireFacebookCompleteRegistration = () =>
  fireFacebookEvent(FACEBOOK_EVENTS.COMPLETE_REGISTRATION);

export const fireFacebookContact = () =>
  fireFacebookEvent(FACEBOOK_EVENTS.CONTACT);
